import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 700,
    // border: '1px solid #e7e7e7',
    margin: 'auto',
    padding: 16,
    borderRadius: 16,
    position: 'relative',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: { width: '100%' }
  },
  titleContainer: {
    width: '100%',
    position: 'absolute',
    top: -20
  },
  title: {
    width: 'fit-content',
    margin: 'auto',
    paddingLeft: 8,
    paddingRight: 8,
    background: theme.palette.background.paper
  },
  icon: {
    width: '32%'
  },
  iconDelete: {
    fontSize: 42,
    marginTop: 24,
    marginBottom: 16
  },
  item: {
    position: 'relative',
    width: 700,
    margin: 'auto',
    borderRadius: 16,
    outline: 'none',
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: { width: '100%' }
  },
  parentDiv: {
    padding: 16,
    margin: 'auto',
    borderRadius: 16,
    outline: 'none',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    zIndex: 1
  },
  thumbnail: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[200],
    marginRight: 12,
    [theme.breakpoints.down('sm')]: {
      width: 40,
      height: 40
    }
  },

  details: {
    flex: 1
  },
  linkIcon: {
    transform: 'rotate(-45deg)',
    '& svg': { color: theme.palette.primary.main }
  },
  img: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    opacity: 0,
    transition: 'opacity 0.25s linear'
  },
  imgVisible: {
    opacity: 1
  },
  progressbar: {
    position: 'absolute',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    zIndex: 0
  },
  itemError: {
    background: 'linear-gradient(to right, #ff7272 , white, #ffdcdc)'
  },
  skeletonImageBoxName: { width: '80%' },
  skeletonImageBoxSize: {
    width: '10%',
    [theme.breakpoints.down('sm')]: {
      width: '50%'
    }
  }
}))

export default useStyles
